var map = {
	"./esports-bg.webp": 1651,
	"./esports-ctg.webp": 1652,
	"./im-img.webp": 1653,
	"./im-title-cn.webp": 1654,
	"./im-title-en.webp": 1655,
	"./object-1.webp": 1656,
	"./object-2.webp": 1657,
	"./object-3.webp": 1658,
	"./object-4.webp": 1659,
	"./tfg-img.webp": 1660,
	"./tfg-title-cn.webp": 1661,
	"./tfg-title-en.webp": 1662,
	"./title-cn.webp": 1663,
	"./title-en.webp": 1664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1650;